export var CLOSE_BUTTON_HEIGHT = 34;
export var FULL_WIDTH_SIDE_PADDING = 32;
export var CONTAINER_MAX_WIDTH = 1280;